
import tap_01_img01 from './static/tap_01_img01.png'
import tap_01_img02 from './static/tap_01_img02.png'
import tap_01_img03 from './static/tap_01_img03.png'
import tap_01_img04 from './static/tap_01_img04.png'
import tap_01_img05 from './static/tap_01_img05.png'


import tap_03_img01 from './static/tap_03_img01.png'

import tap_04_img01 from './static/tap_04_img01.png'
import tap_04_img02 from './static/tap_04_img02.png'
import tap_04_img04 from './static/tap_04_img04.png'
import tap_04_img06 from './static/tap_04_img06.png'
import tap_04_img07 from './static/tap_04_img07.png'
import tap_04_img09 from './static/tap_04_img09.png'



import tap_06_img01 from './static/tap_06_img01.png'
import tap_06_img02 from './static/tap_06_img02.png'

import tap_07_img from './static/tap_07_img.png'

import tap_07_img01 from './static/tap_07_img01.png'
import tap_07_img02 from './static/tap_07_img02.png'
import tap_07_img03 from './static/tap_07_img03.png'
import tap_07_img04 from './static/tap_07_img04.png'
import tap_07_img05 from './static/tap_07_img05.png'
import tap_07_img06 from './static/tap_07_img06.png'



import tap_08_img from './static/tap_08_img.png'

import tap_09_img01 from './static/tap_09_img01.png'
// import tap_09_img02 from './static/tap_09_img02.png'

import tap_10_img from './static/tap_10_img.png'

import tap_stop_img from './static/tap_stop_img.png'



import tap_button1_img from './static/tap_button1_img.png'
import tap_button2_img from './static/tap_button2_img.png'
import tap_button3_img from './static/tap_button3_img.png'
import tap_button4_img from './static/tap_button4_img.png'



const secView = [

    [
        {
            bg:tap_01_img01,
        },
        {
            icon:tap_01_img02,
            width:200,
            height:179,
            top:820,
            left: 1000,
            event: 2,
            x:0,
            y:0,
            opc:1,
            flag:true,
        },
        {
            icon:tap_01_img03,
            width:102,
            height:195,
            top:808,
            left: 1200,
            event: 2,
            x:0,
            y:0,
            opc:1,
            flag:true,
        },
        {
            icon:tap_01_img04,
            width:210,
            height:366,
            top:640,
            left: 1360,
            event: 2,
            x:0,
            y:0,
            opc:1,
            flag:true,
        },
        {
            icon:tap_01_img05,
            width:387,
            height:611,
            top:450,
            left: 1500,
            event: 2,
            x:0,
            y:0,
            opc:1,
            flag:true,
        }
        
    ],

    [
        {
            bg:tap_03_img01,
            width:2435,
            height:1125,
        },
    ],

    [
        {
            bg:tap_04_img01,
            // width:974,
            // height:450,
        },
        {
            icon:tap_04_img02,
            width:192,
            height:236,
            top:600,
            event: 2,
            x:0,
            y:0,
            opc:1,
            flag:true,
            position: 1,
        },

        {
            icon:tap_04_img04,
            width:393,
            height:288,
            event: 2,
            x:0,
            y:0,
            opc:1,
            flag:true,
            position: 2,
        },

        {
            icon:tap_04_img06,
            width:116,
            height:166,
            event: 2,
            x:0,
            y:0,
            flag:true,
            opc:1,
            position: 1,
        },
        {
            icon:tap_04_img07,
            width:189,
            height:304,
            event: 2,
            x:0,
            y:0,
            flag:true,
            opc:1,
            position: 1,
        },

        {
            icon:tap_04_img09,
            width:331,
            height:349,
            event: 2,
            x:0,
            y:0,
            opc:1,
            flag:true,
            position: 2,
        },
    ],

    [
        {
            bg:tap_06_img01,
        },
        {
            icon:tap_06_img02,
            width:572.2,
            height:333,
            left:500,
            top:280,
            event: 1,
            ani:true
        }
    ],

    [
        {
            bg: tap_07_img,
        },
        {
            icon:tap_07_img01,
            width:344,
            height:436,
            event: 1,
            rate:4,
            flag: 0
        },
        {
            icon:tap_07_img02,
            width:327,
            height:532,
            event: 1,
            rate:4,
            flag: 0
        },
        {
            icon:tap_07_img03,
            width:361,
            height:488,
            event: 1,
            rate:4,
            flag: 0
        },
        {
            icon:tap_07_img04,
            width:444,
            height:512,
            event: 1,
            rate:4,
            flag: 0
        },
        {
            icon:tap_07_img05,
            width:313,
            height:417,
            event: 1,
            rate:4,
            flag: 0
        },
        {
            icon:tap_07_img06,
            width:352,
            height:492,
            event: 1,
            rate:4,
            flag: 0
        },
    ],

    [
        {
            bg: tap_08_img,
            width:2435,
            height:1125,
        },
    ],

    [
        {
            bg: tap_09_img01,
            width:2435,
            height:1125,
            event: 1
        },
    ],

    [
        {
            bg: tap_10_img,
            width:2435,
            height:1125,
        },
    ],

    [       // 7
        {
            bg: tap_stop_img,
            width:2436,
            height:1125,
        },
    ],

    [
        {
            bg: tap_button1_img,
            width:2436,
            height:1125,
        },
    ],

    [
        {
            bg: tap_button2_img,
            width:2436,
            height:1125,
        },
    ],

    [
        {
            bg: tap_button3_img,
            width:2436,
            height:1125,
        },
    ],

    [
        {
            bg: tap_button4_img,
            width:2436,
            height:1125,
        },
    ],

]

export default secView;